import HomeLanding from "./HomeLanding";
import HomeLandingLocalEconomy from "./HomeLandingLocalEconomy";
import HomeLandingSummer2026 from "./HomeLandingSummer2026";

const variants = {
  original: HomeLanding,
  summer: HomeLandingSummer2026,
  local: HomeLandingLocalEconomy,
};

function getLandingVariant() {
  return "summer";
}

function HomeLandingSwitcher(props) {
  const variant = getLandingVariant();
  const Landing = variants[variant] || HomeLanding;

  return <Landing {...props} landingVariant={variant} />;
}

export default HomeLandingSwitcher;
